import { SoluzioneNode } from '@gql/graphql'
import { GenericSectionThemeType, MenuItemType } from '@utils/types'
import { CardSwiper } from '@components/organisms'
import styles from './SoluzioniSection.module.sass'
import useTrans from '@hooks/useTrans'

interface Props {
  soluzioni: SoluzioneNode[]
  item: MenuItemType
  theme?: GenericSectionThemeType
  className?: string
}

const SoluzioniSection = (props: Props) => {
  const { soluzioni = [], item = undefined, theme = 'neutral20', className = '' } = props

  const t = useTrans()

  return soluzioni?.length ? (
    <CardSwiper
      id={'soluzioni-swiper'}
      item={{
        name: t('Soluzioni'),
        ...item, // Override
        children: soluzioni.map((x) => ({
          pk: x.pk,
          name: x.title,
          image: x.image,
          alt: x.imageAlt,
          url: x.url
        })),
      }}
      theme={theme}
      size="md"
      className={`${styles.root} ${className}`}
    />
  ) : (
    <></>
  )
}

export default SoluzioniSection
